import React, {VoidFunctionComponent} from 'react';

import a11yClick from '../../libs/a11y-click';

import styles from './dark-mode-toggle.module.css';

interface Props {
  toggleDarkMode: () => void;
}

const DarkModeToggle: VoidFunctionComponent<Props> = props => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (a11yClick(event)) {
      event.currentTarget.click();
    }
  };

  return (
    <>
      <input
        id="darkModeToggle"
        type="checkbox"
        className={styles.checkbox}
        onChange={props.toggleDarkMode}
      />
      <label
        className={styles.darkModeToggle}
        htmlFor="darkModeToggle"
        onKeyDown={handleKeyDown}
        tabIndex={0}></label>
    </>
  );
};

export default DarkModeToggle;
